import { render, staticRenderFns } from "./auth-finish-registration.vue?vue&type=template&id=1b1932f3&scoped=true&"
import script from "./auth-finish-registration.vue?vue&type=script&lang=js&"
export * from "./auth-finish-registration.vue?vue&type=script&lang=js&"
import style0 from "./auth-finish-registration.vue?vue&type=style&index=0&id=1b1932f3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1932f3",
  null
  
)

export default component.exports